module.exports = __webpack_public_path__ + "static/media/roaster_pin.40688f12.png";